import ko from 'knockout';
import { defineComponent } from '@/gr/common/knockout/defineComponent';
import { Trend, TrendServices, OutputChannelContainerArgsFactory, ITrendResourceDto, IProductDto, DetectTrendChangedService } from '@/apps/timeSeriesViewer';
import { CompositeDisposable } from '@/gr/common/disposable';
import { EmbedService } from '@/apps/timeSeriesViewer/components/embeddableArtifactComponent/embedService';
import { EmbeddableContainerArgsFactory, IEmbeddableContainerArgs } from './embeddableContainerArgsFactory';
import Vue from 'vue';
import { Container } from '@/container';
import { EmbeddableArtifactEntryPointArgs } from '@/repositories';
import html from './embeddableArtifactComponent.html';
import { EmbeddableContainerArgs } from '../embeddableContainer/embeddableContainer';
import { TimeControl } from '@/common/timeContext';

export interface IEmbeddableArtifactEntryPointArgs {
  embedBaseUrl: string;
  product: IProductDto;
  apiVersion: string;
  trendResource: ITrendResourceDto;
  container: IEmbeddableContainerArgs;
}

export class Component {
  private readonly _dependencyContainer: Container;
  private readonly _disposable = new CompositeDisposable();
  private readonly _timeControl;
  private readonly _trend = new Trend();
  private readonly _services: TrendServices;
  private readonly _outputChannelContainerArgsFactory: OutputChannelContainerArgsFactory;
  private readonly _embedService: EmbedService;

  readonly isLoadingApp = ko.observable(true);
  readonly isLoadingPart = this._trend.isLoadingPart;
  readonly messages = this._trend.messages;
  readonly modalErrorDialog = { html: ko.observable<string>() };
  readonly embeddableContainer: EmbeddableContainerArgs;

  readonly selectedOutputChannelContainer = ko.pureComputed(() => {
    return this._outputChannelContainerArgsFactory.create(this._trend.selectedOutputChannelContainer());
  });

  constructor(private _args: Args) {
    this._dependencyContainer = this._args.vue.$store.state.dependencyContainer as Container;
    this._timeControl = TimeControl.get(this._args.vue.$router);
    this._services = new TrendServices(this._trend, this._args.entryPointArgs.apiVersion, this._timeControl, () => window.location.reload(), null, this._args.vue.$authentication);
    this._outputChannelContainerArgsFactory = new OutputChannelContainerArgsFactory(this._trend, this._services);
    this._embedService = new EmbedService(this._args.entryPointArgs.embedBaseUrl);
    this.embeddableContainer = new EmbeddableContainerArgsFactory(this._embedService, this._trend.title, this._args.entryPointArgs.container).create();

    this._trend.productName = this._args.entryPointArgs.product.name;
    this._trend.prereleaseTag = this._args.entryPointArgs.product.prereleaseTag;
    this._trend.appVersion = this._args.entryPointArgs.apiVersion;
    this.loadTrend();
    this._disposable.add(this._services);
  }

  private async loadTrend() {
    await this._services.trendsRepository.loadDtoInto(this._trend, this._args.entryPointArgs.trendResource);
    this._trend.isReadOnlyMode(true);
    this._trend.isTrendEmbeddable(true);
    this._disposable.add(DetectTrendChangedService.reloadWindowWhenChanges(this._trend.id, this._trend.lastSavedTime, this._services.artifactsRepository));
    this.isLoadingApp(false);
  }

  dispose(): void {
    this._disposable.dispose();
  }
}

export class Args {
  constructor(
    public entryPointArgs: IEmbeddableArtifactEntryPointArgs,
    public vue: Vue
  ) {}
}

export class ArgsFactory {
  async create(args: EmbeddableArtifactEntryPointArgs, vue: Vue): Promise<Args> {
    return new Args(args as unknown as IEmbeddableArtifactEntryPointArgs, vue);
  }
}

defineComponent(() => Component, 'embeddableArtifactComponent', html);
require('./embeddableArtifactComponent.less');
